var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { ChevronLeft, ChevronRight } from '../../foundations/icons';
import styles from './TextLink.module.scss';
export var TextLinkComponent = function (_a, ref) {
    var _b;
    var component = _a.component, componentProps = _a.componentProps, _c = _a.size, size = _c === void 0 ? 'inherit' : _c, _d = _a.iconLeft, iconLeft = _d === void 0 ? false : _d, _e = _a.iconRight, iconRight = _e === void 0 ? false : _e, _f = _a.light, light = _f === void 0 ? false : _f, _g = _a.underline, underline = _g === void 0 ? 'default' : _g, disabled = _a.disabled, children = _a.children, className = _a.className, rest = __rest(_a, ["component", "componentProps", "size", "iconLeft", "iconRight", "light", "underline", "disabled", "children", "className"]);
    var Component = component || 'a';
    var classes = cx(className, styles.basic, styles[size], (_b = {},
        _b[styles.light] = light,
        _b[styles.disabled] = disabled,
        _b[styles["underline-".concat(underline)]] = underline !== 'hover',
        _b));
    return (React.createElement(Component, __assign({ ref: ref, role: component === 'button' ? 'button' : 'link', "aria-disabled": disabled }, rest, componentProps, { className: classes }),
        iconLeft && React.createElement(ChevronLeft, { size: "small", className: styles.iconLeft }),
        children,
        iconRight && React.createElement(ChevronRight, { size: "small", className: styles.iconRight })));
};
/**
 * @tdr
 * @tdr-candidates: a
 */
export var TextLink = forwardRef(TextLinkComponent);
//# sourceMappingURL=TextLink.js.map